import React, { useEffect } from "react";
import SimpleModal from "components/Modal/SimpleModal";
import { Button, Col, Form, Input, Row, Spin } from "antd";
import IntlMessages from "util/IntlMessages";
import { useSelector, useDispatch } from "react-redux";
import { DataRequestActionAPI } from "../../../../redux/actions/http";

const EditItemModal = () => {
  const dispatch = useDispatch();
  const inventoryProps = useSelector((state) => state.inventory);
  const {
    inventorySpinner,
    inventorySuccess,
    editItemModalVisible,
    initialValues,
  } = inventoryProps;

  const [form] = Form.useForm();
  console.log("initialValues", initialValues);

  const editItem = (values) => {
    let payload = {
      id: initialValues._id,
      ...values,
    };
    dispatch(
      DataRequestActionAPI(
        "PUT",
        "updateHealthBand",
        "EditInventory",
        payload,
        "",
        "InventoryLoading",
        true
      )
    );
  };

  useEffect(() => {
    if (inventorySuccess) {
      toggleEditItemModal();
    }
  }, [inventorySuccess]);

  const toggleEditItemModal = () => {
    dispatch({ type: "Hide_EditItem_Modal" });
    form.resetFields();
  };

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues, form]);

  return (
    <>
      <SimpleModal
        visible={editItemModalVisible}
        width={500}
        modalFor="Hide_EditItem_Modal"
        // closeFn={toggleAddItemModal}
        title={<IntlMessages id="inventory.editItem" />}
      >
        <Form
          form={form}
          layout="vertical"
          name="editItem"
          onFinish={editItem}
          initialValues={initialValues}
        >
          <Row className="gx-d-flex gx-flex-row">
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-pl-0">
              <Form.Item
                name="imei"
                label={<IntlMessages id="inventory.imei" />}
                rules={[
                  {
                    required: true,
                    message: <IntlMessages id="inventory.imei_message" />,
                  },
                ]}
              >
                <Input type="number" disabled />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
              <Form.Item
                name="name"
                label={<IntlMessages id="inventory.name" />}
                rules={[
                  {
                    required: true,
                    message: <IntlMessages id="inventory.name_message" />,
                  },
                ]}
              >
                <Input type="alphabets" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
              <Form.Item
                name="model"
                label={<IntlMessages id="inventory.model" />}
                rules={[
                  {
                    required: true,
                    message: <IntlMessages id="inventory.model_message" />,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
              <Form.Item
                name="notes"
                label={<IntlMessages id="inventory.notes" />}
                rules={[
                  {
                    required: false,
                    // message: <IntlMessages id="inventory.notes_message" />,
                  },
                ]}
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
              <div className="gx-flex gx-flex-row gx-align-items-center gx-justify-content-end ">
                <Form.Item className="gx-mb-0">
                  <Button
                    type="default"
                    className="gx-pt-0 gx-mb-0 gx-mr-2"
                    htmlType="button"
                    onClick={toggleEditItemModal}
                  >
                    <IntlMessages id="inventory.cancel" />
                  </Button>
                </Form.Item>
                <Form.Item className="gx-mb-0">
                  {inventorySpinner ? (
                    <Spin>
                      <Button
                        type="primary"
                        className="gx-pt-0 gx-mb-0"
                        disbaled
                        htmlType="button"
                      >
                        <IntlMessages id="inventory.save" />
                      </Button>
                    </Spin>
                  ) : (
                    <Button
                      type="primary"
                      className="gx-pt-0 gx-mb-0"
                      htmlType="submit"
                    >
                      <IntlMessages id="inventory.save" />
                    </Button>
                  )}
                </Form.Item>
              </div>
            </Col>
          </Row>
        </Form>
      </SimpleModal>
    </>
  );
};

export default EditItemModal;
